const formatSizeLimitError = (string) => {
  const fileSizeLimits = {
    emailAttachments: '5.2MB',
    files: '25.0MB',
  }

  Object.entries(fileSizeLimits).forEach(([key, value]) => {
    if (string.includes(value)) {
      const formattedValue = value.replace('.', ',').replace('MB', ' MB')
      string = string.replace(value, `${formattedValue}`)
    }
  })

  return string
}

export default formatSizeLimitError
